import * as React from 'react';
import { connect } from "react-redux";
import { VER_NUM } from '../../config/version';
import headerReduxProps from "../Header/HeaderReduxProps";
import './Footer.css';
var Footer = function (props) {
    return (React.createElement("footer", { className: "app-footer " + (props.sidebarVisible ? "" : "expand") },
        React.createElement("div", { className: "shrinkText " + (props.sidebarVisible ? "shrinkTextSidebarVisible" : "") },
            React.createElement("a", { href: "http://prettyshop.com/" }, "prettyshop\u00A0"),
            React.createElement("span", null, "\u00A9 2020 prettyshop."),
            "\u00A0"),
        React.createElement("div", { className: "shrinkText " + (props.sidebarVisible ? "shrinkTextSidebarVisible" : "") }, VER_NUM.length === 0 ? null : React.createElement("span", { className: "ver_num" },
            "Ver. # ",
            VER_NUM))));
};
export default connect(headerReduxProps.mapStateToProps, headerReduxProps.mapDispatchToProps)(Footer);



//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Footer.tsx
// module id = 206
// module chunks = 0